module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"txt_btn":"Editar ponderación","titulo":"Ponderación indicadores prestacionales","suma":"Suma total","suma_error":"* la suma total no puede superar el 100%","ponderacion_descrip":"Haciendo clic podrás cambiar los coeficientes de ponderación entres los grupos de indicadores prestacionales."}}')
  delete Component.options._Ctor
}
